import { registerExit, clearExit } from '@/utils/pageTransition';

/**
 * Wire a page component's `exitAnim()` into the navigation interceptor.
 *
 * Add this mixin to any page that defines an `exitAnim()` method returning a
 * GSAP tween/timeline (the inverse of its mounted intro). The interceptor
 * plays it before Inertia loads the next page.
 */
export default {
    mounted() {
        if (typeof this.exitAnim === 'function') {
            registerExit(() => this.exitAnim());
        }
    },
    beforeUnmount() {
        clearExit();
    },
};
